module.exports = __webpack_public_path__ + "static/media/takecare-mobile-1.98552fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/takecarecup/takecare-mobile-1.png
// module id = 137
// module chunks = 0